import { StoredValueAgencyRecordsWithPagination, StoredValueLog, StoredValueTotal } from 'core/storedValue/StoredValueLog';
import client from './RestClient';
import { AxiosInstance } from 'axios';

export interface StoredValueWebService {
  getStoredValueAgencyRecords (page: number, sortField: string, sortOrder: string, search: string): Promise<StoredValueAgencyRecordsWithPagination>;
  getStoredValueLogsByAgencyId (agencyId: number): Promise<StoredValueLog[]>;
  getStoredValueTotal (agencyId: number): Promise<StoredValueTotal>;
  getStoredValueFrozenTotal (agencyId: number): Promise<StoredValueTotal>;
  editStoredValue (agencyId: number, amount: number, action: string, description: string, comment?: string): Promise<void>;
}

export class RestfulStoredValueWebService implements StoredValueWebService {
  constructor (
    private restClient: AxiosInstance = client
  ) {}

  async getStoredValueAgencyRecords (
    page: number,
    sortField: string,
    sortOrder: string,
    search: string
  ): Promise<StoredValueAgencyRecordsWithPagination> {
    let url = `/stored-value?page=${page}&sort=${sortField},${sortOrder}`;
    if (search !== '') {
      url = url + `&search=${encodeURIComponent(search)}`;
    }
    const response = await this.restClient.get(url);
    return response.data;
  }

  async getStoredValueLogsByAgencyId (
    agencyId: number
  ): Promise<StoredValueLog[]> {
    const response = await this.restClient.get(
      `/stored-value/${agencyId}/no-page`
    );
    return response.data.records;
  }

  /**
   * 後端算好的**剩餘**額度（只有 `remainingAmount`）。後端不因呼叫者身分過濾任何 action，
   * 所以這裡拿到的餘額是正確的；供應商拿不到的只有明細清單裡的弭平那一「列」。
   */
  async getStoredValueTotal (
    agencyId: number
  ): Promise<StoredValueTotal> {
    const response = await this.restClient.get(
      `/stored-value/${agencyId}/remaining-amount`
    );
    return response.data;
  }

  /**
   * 後端算好的**凍結**額度（只有 `frozenAmount`），同樣不過濾任何 action。
   *
   * 剩餘與凍結是兩支 endpoint，因為 `remaining-amount` 是 PChome 的對外 open API，
   * 不為了後台顯示把凍結額度塞進它的回傳。
   */
  async getStoredValueFrozenTotal (
    agencyId: number
  ): Promise<StoredValueTotal> {
    const response = await this.restClient.get(
      `/stored-value/${agencyId}/frozen-amount`
    );
    return response.data;
  }

  async editStoredValue (
    adAgencyId: number,
    amount: number,
    action: string,
    description: string,
    comment: string = ''
  ): Promise<void> {
    return this.restClient.post(`/stored-value`, {
      amount,
      comment,
      description,
      adAgencyId,
      action
    });
  }
}
